import React from "react"

export default {
    wrapper: {
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "white"
    } as React.CSSProperties,
    leftPanel: {
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        width: 300,
        backgroundColor: "#F8F8FB"
    } as React.CSSProperties,
    centerPanel: {
        position: "absolute",
        left: 300,
        right: 300,
        top: 0,
        bottom: 0,
        borderLeft: "solid 1px lightgray",
        borderRight: "solid 1px lightgray",
        overflow: "auto",
        whiteSpace: "nowrap"

    } as React.CSSProperties,
    rightPanel: {
        position: "absolute",
        right: 0,
        top: 0,
        bottom: 0,
        width: 300,
        backgroundColor: "#F8F8FB"
    } as React.CSSProperties,
    toolBar: {
        backgroundColor: "#eee",
        minHeight: 48
    } as React.CSSProperties,


}